import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import {
    Grid,
    GridNoRecords,
    GridColumn as Column,
} from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

import BobLoadingMask from '../../../components/BobLoadingMask';

import * as classes from './PowerGrid.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const PowerGrid = ({
    bobLoading,
    data,
    entity,
    hasInitialized,
    workbookModeEnabled,
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);
    const [pageable] = useState({ pageSizes: true });

    const [currentData, setCurrentData] = useState([]);

    useEffect(() => {
        if (!isEmpty(data)) {
            data.energyTimeSeries.currentTimeSeries.forEach((item, index) => {
                item.priorEnergyUse = data.energyTimeSeries.priorTimeSeries[index].energyUse;
                item.energyTarget = data.targetAverageValue;
            });
            setCurrentData(data.energyTimeSeries.currentTimeSeries);
        }
    }, [data]);

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    return (
        <div className={classes.Table}>
            <Grid
                sortable={{
                    mode: 'multiple'
                }}
                className={classes.KendoGrid}
                data={kendoProcess(currentData, dataState)}
                {...dataState}
                onDataStateChange={onDataStateChange}
                pageable={pageable}
                reorderable
                filterable={workbookModeEnabled}
            >
                {
                    !hasInitialized ?
                        <GridNoRecords>
                            {`Loading ${entity} energy records`}
                        </GridNoRecords>
                        :
                        <GridNoRecords>
                            {`No ${entity} energy records`}
                        </GridNoRecords>
                }
                <Column
                    field="start"
                    title="Time Stamp"
                    width="auto"
                    sortable={true}
                    filterable={true}
                    filter="date"
                />
                <Column
                    field="name"
                    title="Equipment"
                    width={300}
                    sortable={true}
                    filterable={true}
                    filter="text"
                />
                <Column
                    field="energyUse"
                    title="Power, kW"
                    width={300}
                    sortable={true}
                    filterable={true}
                    filter="number"
                />
                <Column
                    field="priorEnergyUse"
                    title="Power, kW (Previous Period)"
                    width={300}
                    sortable={true}
                    filterable={true}
                    filter="number"
                />
                <Column
                    field="energyTarget"
                    title="Target, Avg kW"
                    width={300}
                    sortable={true}
                    filterable={true}
                    filter="number"
                />
            </Grid>
            {
                bobLoading.includes('FetchEquipmentEnergyData') || bobLoading.includes('FetchSiteEnergyData') || !hasInitialized ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    bobLoading:          state.bob.bobLoading,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

export default connect(mapStateToProps, null)(PowerGrid);
